import {
  JOB_APPLICATION_MATCH_STATUS,
  JOB_APPLICATION_MATCH_SUB_STATUS,
} from "lookup";

export const CTA_TITLES = {
  accept: "Manually marks talent as Accepted.",
  addLink: "Adds a custom link to this talent or match record.",
  adminTool: "Opens the Admin Tool page for this talent.",
  actionMenu: "Opens the action menu for this talent.",
  apply:
    "Mark this interested talent as a successful applicant and move them to the 'Applied' status.",
  assessments:
    "Opens assessments to view completed results and send new assessments.",
  copyEmail: "Copies this talent's email address.",
  copyPhone: "Copies this talent's phone number.",
  candidateQuestions: "View and manage candidate questions for this match.",
  deleteMatch: "Unmatches the talent from this job.",
  downloadOriginalFile: "Downloads the original uploaded resume file.",
  downloadResume: "Opens the PDF-converted version of the resume.",
  editProfile: "Opens the modal to edit talent profile information.",
  email: "Opens an email to this talent.",
  findPerfectFitJobs: "Opens job recommendations for this talent.",
  finalist: "Marks or unmarks talent as Finalist for this match.",
  match: "Moves talent to Matched status and opens the pitch modal.",
  matchNotes: "Opens notes about this specific match.",
  moreInfo: "Opens detailed match information.",
  openPlatformProfile: "Opens the talent's public platform profile.",
  phone: "Starts a phone call with this talent.",
  reject: "Rejects matched talent with a reason.",
  sendAssessment: "Select and send an assessment to the talent.",
  sendConfirmationEmail:
    "Sends an email to this unclaimed user to claim their account.",
  setRate: "Opens the modal to set the customer rate.",
  sfdcMatch: "Opens this match's Salesforce record.",
  sfdcUser: "Opens this talent's Salesforce user record.",
  shortlist: "Moves talent to Shortlisted status for review.",
  skip: "Moves talent to Skipped status and removes them from the current view.",
  socialLinks: "Opens this talent's contact and social links.",
  uploadResume: "Uploads or replaces this talent's resume.",
  userNotes: "Opens notes about this talent.",
  viewFullProfile: "Opens the full profile card with all talent information.",
  whatsApp: "Opens a WhatsApp chat with this talent.",
};

export const getSocialLinkTitle = (label) =>
  `Opens this talent's ${label} profile in a new tab.`;

export const MATCH_STATUS_TITLES = {
  [JOB_APPLICATION_MATCH_STATUS.MATCHED]: {
    label: "Matched",
    icon: "heart",
    filledIcon: true,
    title: "MATCHED - Initial match created by the system or matcher",
  },
  [JOB_APPLICATION_MATCH_STATUS.APPLIED]: {
    label: "Applied",
    icon: "clipboardCheck",
    title: "APPLIED - Talent has applied to the job",
  },
  [JOB_APPLICATION_MATCH_STATUS.INTERESTED]: {
    label: "Interested",
    icon: "userCheck",
    title: "INTERESTED - Talent expressed interest in the opportunity",
  },
  [JOB_APPLICATION_MATCH_STATUS.INTERESTEDFASTTRACK]: {
    label: "Interested",
    icon: "userCheck",
    title: "INTERESTEDFASTTRACK - Talent interested via fast-track process",
  },
  [JOB_APPLICATION_MATCH_STATUS.PRESHORTLISTED]: {
    label: "Pre-shortlisted",
    icon: "bookmarkX",
    title: "PRESHORTLISTED - Pre-candidate status (early filtering)",
  },
  [JOB_APPLICATION_MATCH_STATUS.TKSHORTLISTED]: {
    label: "Pre-shortlisted",
    icon: "bookmarkX",
    title: "TKSHORTLISTED - Pre-candidate status (TextKernel shortlist)",
  },
  [JOB_APPLICATION_MATCH_STATUS.SHORTLISTED]: {
    label: "Shortlisted",
    icon: "bookmark",
    filledIcon: true,
    title: "SHORTLISTED - Candidate shortlisted for consideration",
  },
  [JOB_APPLICATION_MATCH_STATUS.MOREINFO]: {
    label: "Info missing",
    icon: "circleHelp",
    title: "MOREINFO - More information needed (CSM action required)",
  },
  [JOB_APPLICATION_MATCH_STATUS.OFFERSENT]: {
    label: "Offer sent",
    icon: "fileText",
    title: "OFFERSENT - Offer has been sent to the talent",
  },
  [JOB_APPLICATION_MATCH_STATUS.ACCEPTED]: {
    label: "Accepted for the role",
    icon: "star",
    filledIcon: true,
    title: "ACCEPTED - Match accepted (talent selected for the role)",
  },
  [JOB_APPLICATION_MATCH_STATUS.REJECTEDBYCUSTOMER]: {
    label: "Rejected by customer",
    icon: "monitorX",
    title: "REJECTEDBYCUSTOMER - Customer rejected the candidate",
  },
  [JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMEMBER]: {
    label: "Rejected by talent",
    icon: "monitorX",
    title: "REJECTEDBYMEMBER - Talent rejected the opportunity",
  },
  [JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMATCHER]: {
    label: "Rejected by matcher",
    icon: "monitorX",
    title: "REJECTEDBYMATCHER - Matcher/recruiter rejected the match",
  },
  [JOB_APPLICATION_MATCH_STATUS.PASSEDON]: {
    label: "Passed on",
    icon: "monitorX",
    title: "PASSEDON - Passed on the opportunity",
  },
  [JOB_APPLICATION_MATCH_STATUS.SKIPPED]: {
    label: "Skipped",
    icon: "chevronsRight",
    title: "SKIPPED - Match was skipped",
  },
  [JOB_APPLICATION_MATCH_STATUS.DELETED]: {
    label: "Deleted",
    icon: "trash2",
    title: "DELETED - Match record deleted",
  },
  [JOB_APPLICATION_MATCH_SUB_STATUS.FINALIST]: {
    label: "Finalist",
    icon: "star",
    filledIcon: true,
    title: "FINALIST - Talent is a finalist for the role",
  },
};
